var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"aha-button relative",class:[
    `aha-button-${_vm.size}`,
    `aha-button-${_vm.variant}`,
    {
      'mr-4': _vm.hasMarginRight,
      'ml-4': _vm.hasMarginLeft,
    }
  ],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{class:{
      'opacity-0' : _vm.submitting,
      'visibility-collapse': _vm.submitting
    }},[_vm._t("default")],2),_c('span',{staticClass:"aha-spinner",class:{
      'opacity-0' : !_vm.submitting,
      'visibility-collapse': !_vm.submitting,
      'opacity-100' : _vm.submitting,
      'mx-unset': _vm.submitting,
      'aha-spinner--dark': _vm.spinnerVariant == 'dark',
      'aha-spinner--white': _vm.spinnerVariant == 'white',
      'aha-spinner--tail': _vm.spinnerVariant == 'tail',
      'aha-spinner--xs': _vm.spinnerSize == 'xs',
      'aha-spinner--sm': _vm.spinnerSize == 'sm',
      'aha-spinner--md': _vm.spinnerSize == 'md',
      'aha-spinner--lg': _vm.spinnerSize == 'lg',
      'aha-spinner--xl': _vm.spinnerSize == 'xl'
    }})])
}
var staticRenderFns = []

export { render, staticRenderFns }